import { ReactComponent as HomeIcon } from "../assets/sidebar/start.svg";
import { ReactComponent as UsersIcon } from "../assets/sidebar/users.svg";
import { ReactComponent as SubscriptionsIcon } from "../assets/sidebar/subscriptions.svg";
import { ReactComponent as NewsLetterIcon } from "../assets/sidebar/newsletter.svg";
interface SidebarChild {
  key: string;
  label: string;
  path: string;
  permission: string;
}

export interface SidebarSection {
  key: string;
  label: string;
  icon: JSX.Element;
  path: string;
  permission?: string;
  children?: SidebarChild[];
}

export const SIDEBAR_SECTIONS: SidebarSection[] = [
  {
    key: "0",
    label: "Mapa acústico",
    icon: <HomeIcon />,
    path: "/admin/map",
    permission: "ui:map",
    children: [
      {
        key: "01",
        label: "Biomasa por punto",
        path: "/admin/map/1",
        permission: "ui:map:point",
      },
      {
        key: "02",
        label: "Biomasa por transecto",
        path: "/admin/map/2",
        permission: "ui:map:transect",
      },
    ],
  },
  {
    key: "3",
    label: "Boletines Oceanográficos",
    icon: <NewsLetterIcon />,
    path: "/admin/reports",
    permission: "ui:newsletter",
  },
  {
    key: "1",
    label: "Gestor de usuarios",
    icon: <UsersIcon />,
    path: "/admin/users",
    permission: "ui:users",
    children: [
      {
        key: "10",
        label: "Dashboard",
        path: "/admin/dashboard",
        permission: "ui:dashboard:view",
      },
      {
        key: "14",
        label: "Roles y perfiles",
        path: "/admin/roles",
        permission: "ui:roles:view",
      },
      {
        key: "12",
        label: "Usuarios",
        path: "/admin/users",
        permission: "ui:users:view",
      },
      {
        key: "13",
        label: "Mi perfil",
        path: "/admin/profile",
        permission: "ui:profile:view",
      },
    ],
  },
  {
    key: "2",
    label: "Suscripciones",
    icon: <SubscriptionsIcon />,
    path: "/admin/subscriptions",
    permission: "ui:subscriptions",
    children: [
      {
        key: "20",
        label: "Planes",
        path: "/admin/subscription-plans",
        permission: "ui:subscription-plans:view",
      },
      {
        key: "21",
        label: "Suscripciones",
        path: "/admin/subscriptions",
        permission: "ui:subscriptions:view",
      },
      {
        key: "22",
        label: "Gestor de suscripciones",
        path: "/admin/manage-subscriptions",
        permission: "ui:subscriptions:manage",
      },
      {
        key: "23",
        label: "Pagos",
        path: "/admin/payments",
        permission: "ui:purchases:view",
      },
    ],
  },
  {
    key: "5",
    label: "Parámetros del Sistema",
    icon: <SubscriptionsIcon />,
    path: "/admin/system-parameters",
    permission: "ui:system:config",
  },
];
